export default __webpack_public_path__ + "static/industryadaptbg-3c51167c15e66f5c64f69dd1b0fae5ef.png";